import { createContext, useContext, useEffect, useState } from 'react';

import { useAxios } from './useAxios';

const UserContext = createContext(null);

export function UserProvider({ children }) {
  const axios = useAxios();

  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;

    const fetchUser = async () => {
      try {
        const response = await axios.get('/auth/me');

        if (!mounted) return;

        setUser(response.data || null);
      } catch (error) {
        if (!mounted) return;

        // 401 = utilisateur non connecté.
        if (error.response?.status !== 401) {
          console.error("Erreur lors de la récupération de l'utilisateur:", error);
        }

        setUser(null);
      } finally {
        if (mounted) {
          setLoading(false);
        }
      }
    };

    fetchUser();

    return () => {
      mounted = false;
    };
  }, [axios]);

  return (
    <UserContext.Provider
      value={{
        user,
        loading,
        isAuthenticated: Boolean(user),
      }}
    >
      {children}
    </UserContext.Provider>
  );
}

// eslint-disable-next-line react-refresh/only-export-components
export function useUser() {
  return useContext(UserContext);
}
